var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{attrs:{"small":"","color":_setup.chipInfoMapping[_setup.esrsStatus].color,"text-color":_setup.esrsStatus === 'notAssessed' ? '#8FA5AF' : '#FFFFFF'}},[_vm._v("\n  "+_vm._s(_vm.$t(_setup.chipInfoMapping[_setup.esrsStatus].key))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }